import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { NetworkBookingsComponent } from '../../../../../pages/network/network-bookings/network-bookings.component';

export const networkBookings: Route = {
  path: 'network-bookings',
  data: {
    breadcrumb: 'lang.globals.playoutDescriptor',
    title: 'lang.globals.playoutDescriptor',
    icon: SbIcons.bookings,
    id: RoutingID.networkBookings,
  },
  children: [
    {
      path: '',
      component: NetworkBookingsComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
